import React from "react";
import { useI18n } from "@/context/I18nContext";
import LegalLayout, { H2, P, UL, ContactCard } from "./LegalLayout";
import { LEGAL } from "./content";

export default function LegalPage({ pageKey, testId }) {
  const { lang } = useI18n();
  const page = LEGAL[pageKey];
  const c = page[lang] || page.en;

  return (
    <LegalLayout title={c.title} effectiveDate={c.effectiveDate} testId={testId}>
      {c.blocks.map((b, i) => {
        if (b.t === "h2") return <H2 key={i}>{b.text}</H2>;
        if (b.t === "ul") return <UL key={i} items={b.items} />;
        if (b.t === "contact") return <ContactCard key={i} lang={lang} />;
        if (b.t === "email")
          return (
            <P key={i}>
              {b.text}{" "}
              <a href={`mailto:${b.mail}`} className="text-primary hover:underline">
                {b.mail}
              </a>
            </P>
          );
        return <P key={i}>{b.text}</P>;
      })}
    </LegalLayout>
  );
}
